module.exports = __webpack_public_path__ + "img/3-4.a4d09ada.png";